module.exports = __webpack_public_path__ + "static/media/grey_nobg.c0fda8c8.png";